import CatSubGradeDropdown from '@/components/cat-sub-grade-drpdn/cat-sub-grade-drpdn';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'min-starting-diagnostic',
    components: {
        'material-icons': GoogleMaterialIcon,
        'cat-sub-grade-drpdn': CatSubGradeDropdown,
    },
})

export default class MinStartingDiagnostic extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop()
    private categorySubjectData: any;

    @Prop()
    private value: any;

    @Prop()
    private isReadOnly: any;

    private score: any;

    private minScore: any;

    private content: any = {};

    private categoryList: any = [];

    private dataPropsValues: any = [];

    private dataStringValue: any = '';

    private isExpand: boolean = false;

    private indexNumber: number = 5;

    private displayObject: any = {};

    @Watch('categorySubjectData')
    private onWatchData(data: any) {
        if (data && data.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    // ---------------------------------------------------------------------
    // Methods

    private updateScore(value: any) {
        this.$emit('input', value);
    }

    private created() {
        // this.value = {'INTM.K12.MA': 1712, 'INTS.K12.NMS': 1806};
        this.content = this.value;
        if (this.content) {
            this.showPreSelected();
        }
        // this.fetchDisplayProp();
    }

    private mounted() {
        if (this.categorySubjectData && this.categorySubjectData.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    private async fetchDisplayPropParent() {
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];
        const categoryList = this.categorySubjectData;
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    orginalVaue: `${prop}: ${valueData[prop]}`,
                    gradeID: valueData[prop],
                    categoryId: propSplit[1],
                    subjectId: `${propSplit[1]}.${propSplit[2]}`,
                    frameworkId: propSplit[0],
                };
                dataValuesCalculate.push(data);
            }
        }
        let gradeList: any = [];
        for await (const [index, iterator] of dataValuesCalculate.entries()) {
            const selectedCategoryIndex = categoryList.findIndex((catItem: any) => {
                return catItem.code === iterator.categoryId;
            });
            if (selectedCategoryIndex !== -1) {
                const selectedSubjectIndex = categoryList[selectedCategoryIndex].subjectList.findIndex((item: any) => {
                    return item.id === iterator.subjectId;
                });
                const selectedSubject = categoryList[selectedCategoryIndex].subjectList[selectedSubjectIndex];
                iterator.subjectTitle = selectedSubject.title;
            }

            gradeList = await this.getSubjectForGrdaesWithFWCode(iterator.subjectId, iterator.frameworkId);
            const selectedGradeIndex = gradeList.findIndex((item: any) => {
                return item.id === iterator.gradeID;
            });
            if (selectedGradeIndex !== -1) {
                iterator.gradeName = gradeList[selectedGradeIndex].grade;
            }
        }
        this.dataPropsValues = dataValuesCalculate;
    }

    private getSubjectList(categoryId: string) {
        return taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            return subjectList;
        });
    }

    private getSubjectForGrdaesWithFWCode(subjectId: any, fwCode: any) {
        return taxonomyAPI.fetchTaxonomyGradesWithFwCode(subjectId, fwCode).then((courses) => {
            return courses ? courses : [];
        });
    }

    private makeStringToShow() {
        const dataValue = this.dataPropsValues;
        let emptyString = '';
        for (const iterator of dataValue) {
            emptyString += `${iterator.categoryId} - ${iterator.subjectTitle} | ${iterator.frameworkId} = ${iterator.keyValue}; `;
        }
        this.dataStringValue = emptyString;
    }

    private showMore() {
        this.indexNumber = this.indexNumber + 5;
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }

    private onAddSelection(selection: any) {
        const category: any = selection.categories.items.find((item: any) => {
            return item.id === selection.categories.selectedItems;
        });
        const subject: any = selection.subjects.items.find((item: any) => {
            return item.id === selection.subjects.selectedItems;
        });
        const framework: any = selection.frameworks.items.find((item: any) => {
            return item.taxonomy_subject_id === selection.frameworks.selectedItems;
        });
        const grade: any = selection.grades.items.find((item: any) => {
            return item.id === selection.grades.selectedItems;
        });
        const onSelected: any = {
            keyName: selection.frameworks.selectedItems,
            orginalVaue: `${selection.frameworks.selectedItems}: ${selection.grades.selectedItems}`,
            gradeID: selection.grades.selectedItems,
            categoryId: category.code,
            categoryTitle: category.title,
            subjectId: selection.subjects.selectedItems,
            subjectTitle: subject.title,
            gradeName: grade.grade,
            grdaeId: grade.id,
            frameworkId: selection.frameworks.selectedItems.split('.')[0],
            fwTitle: framework.title,
            taxonomy_subject_id: selection.frameworks.selectedItems,
        };
        const itemIndex = this.dataPropsValues.findIndex((item: any) => {
            return item.keyName === onSelected.keyName;
        });
        if (itemIndex !== -1) {
            this.dataPropsValues[itemIndex].orginalVaue = onSelected.orginalVaue;
            this.dataPropsValues[itemIndex].gradeID = onSelected.gradeID;
            this.dataPropsValues[itemIndex].gradeName = onSelected.gradeName;
        } else {
            this.dataPropsValues.push(onSelected);
        }
        this.updateValueAsDisplay();
    }

    private deleteItem(removeitem: any, index: any) {
        this.dataPropsValues.splice(index, 1);
        this.updateValueAsDisplay();
    }

    private updateValueAsDisplay() {
        const value: any = {};
        for (const iterator of this.dataPropsValues) {
            value[iterator.taxonomy_subject_id] = iterator.grdaeId;
        }
        this.$emit('input', value);
    }

    private async showPreSelected() {
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];
        const categoryList = await taxonomyAPI.fetchTaxonomyClassifications();
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    orginalVaue: `${prop}: ${valueData[prop]}`,
                    gradeID: valueData[prop],
                    categoryId: propSplit[1],
                    subjectId: `${propSplit[1]}.${propSplit[2]}`,
                    frameworkId: propSplit[0],
                    taxonomy_subject_id: prop,
                };
                dataValuesCalculate.push(data);
            }
        }
        this.categoryList = categoryList;
        let subjectList: any = [];
        let gradeList: any = [];
        for await (const [index, iterator] of dataValuesCalculate.entries()) {
            const selectedCategoryIndex = categoryList.findIndex((catItem: any) => {
                return catItem.code === iterator.categoryId;
            });
            if (index > 0) {
                if (dataValuesCalculate[index].categoryId !== dataValuesCalculate[index - 1].categoryId) {
                    subjectList = await this.getSubjectList(this.categoryList[selectedCategoryIndex].id);
                }
            } else {
                subjectList = await this.getSubjectList(this.categoryList[selectedCategoryIndex].id);
            }
            const selectedSubjectIndex = subjectList.findIndex((item: any) => {
                return item.id === iterator.subjectId;
            });
            const selectedSubject = subjectList[selectedSubjectIndex];
            iterator.subjectTitle = selectedSubject ? selectedSubject.title : '';

            const framework: any = selectedSubject.frameworks.find((item: any) => {
                return item.taxonomy_subject_id === iterator.taxonomy_subject_id;
            });

            gradeList = await this.getSubjectForGrdaesWithFWCode(iterator.subjectId, iterator.frameworkId);
            const selectedGradeIndex = gradeList.findIndex((item: any) => {
                return item.id === iterator.gradeID;
            });
            if (selectedGradeIndex !== -1) {
                iterator.gradeName = gradeList[selectedGradeIndex].grade;
            }

            const onSelected: any = {
                keyName: iterator.taxonomy_subject_id,
                // orginalVaue: `${selection.frameworks.selectedItems}: ${selection.grades.selectedItems}`,
                gradeID: gradeList[selectedGradeIndex].id,
                categoryId: this.categoryList[selectedCategoryIndex].code,
                categoryTitle: this.categoryList[selectedCategoryIndex].title,
                subjectId: selectedSubject.id,
                subjectTitle: selectedSubject.title,
                gradeName: gradeList[selectedGradeIndex].grade,
                grdaeId: gradeList[selectedGradeIndex].id,
                frameworkId: iterator.frameworkId,
                fwTitle: framework.title,
                taxonomy_subject_id: iterator.taxonomy_subject_id,
            };
            const itemIndex = this.dataPropsValues.findIndex((item: any) => {
                return item.keyName === onSelected.keyName;
            });
            if (itemIndex !== -1) {
                this.dataPropsValues[itemIndex].orginalVaue = onSelected.orginalVaue;
                this.dataPropsValues[itemIndex].gradeID = onSelected.gradeID;
                this.dataPropsValues[itemIndex].gradeName = onSelected.gradeName;
            } else {
                this.dataPropsValues.push(onSelected);
            }
        }
    }
}
